import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
    selector: 'app-common-button',
    templateUrl: './common-button.component.html',
    styleUrls: ['./common-button.component.scss']
})

export class CommonButtonComponent {
    @Input() buttonText: string = 'Save';
    @Input() disabled: boolean = false;
    @Input() loading: boolean = false;
    @Input() tooltip: string = '';
    @Output() buttonEvent = new EventEmitter<void>();

    save() {
        this.buttonEvent.emit();
    }
}
